/*
 * Framer-specific All Access landing page. Unlisted, reachable only from a
 * Google ad or by typing the full path — see UI8-9.
 *
 * Deliberately a separate component rather than a variant of pass-details:
 * the real pass page stays byte-identical, and this page is expected to
 * diverge visually later. It shares pass-pricing and the same /api/pass
 * payload, so tiers, prices and the current sale render live and end exactly
 * when the sale ends on /products/all-access-pass. Nothing here is hardcoded
 * about price.
 */
angular.module("UI8.components").component("framerPassDetails", {
  template: `<div class="aap">
      <div class="page__sphere" id="aap-sphere"></div>
      <div class="aap__container container">
        <div class="aap__head">
          <h1 class="aap__title">Every Framer template. One pass.</h1>
          <p class="aap__subtitle">Instant access to 500+ Framer templates and the full UI8 library of 14,000+ products, with new releases every day.</p>
        </div>
        <pass-pricing subscriptions='::$ctrl.data.subscriptions' lifetime='::$ctrl.data.lifetime' promo='::$ctrl.data.promo'></pass-pricing>
        <div class="aap__cancel">Cancel anytime, no questions asked. Your plan stays active through the end of its billing period.</div>
        <div class="aap__picks" ng-if="$ctrl.framerProducts.length">
          <h2 class="home-title">Top Framer templates, all included</h2>
          <div class="catalog">
            <product-card ng-repeat="product in $ctrl.framerProducts track by product._id" product="product" user="$ctrl.user"></product-card>
          </div>
          <div class="aap__picks-cta">
            <button class="new-btn" ng-click="$ctrl.browseFramerTemplates()">Plus over 500 premium templates</button>
          </div>
        </div>
        <div class="docs">
          <div class="docs__title">Got Questions?</div>
          <ul class="docs__list">
            <li class="docs__item">
              <div class="docs__question">What do I get with All Access?</div>
              <div class="docs__answer">All Access unlocks every Framer template on UI8, over 500 of them, with new ones added every week, plus the rest of the library: UI kits, icons, mockups, fonts, 3D assets and more, over 14,000 products in total. It also includes Design DNA, structured design system data you can paste directly into AI coding tools to generate professional-quality UI.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Can I use these for client websites?</div>
              <div class="docs__answer">Yes. Everything you download is licensed for commercial use in client work, your own products and personal projects. The only things you can't do are reshare or resell the files themselves.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Are these Framer projects or Figma files?</div>
              <div class="docs__answer">They're Framer projects. Many also include the matching Figma file, so you can take the design apart before you build on it.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Do I need a paid Framer plan?</div>
              <div class="docs__answer">You need a Framer account, and Framer's free plan is enough to build and publish. Connecting your own domain requires Framer's Basic plan, currently $10 a month billed annually. That's Framer's pricing, not ours.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Do I get all the Framer templates, or a selection?</div>
              <div class="docs__answer">All of them. Every Framer template on UI8 is included on Pro, Pro+ and Lifetime, including new releases. Nothing is held back for a higher tier.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">What happens to sites I've already built if I cancel?</div>
              <div class="docs__answer">Nothing changes. Framer templates are delivered as a remix link, so the project is copied into your own Framer account and lives there permanently. Canceling stops future billing and new downloads. Sites you've already built keep running.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Will my price go up when the sale ends?</div>
              <div class="docs__answer">No. The price you subscribe at today is locked in. You'll keep renewing at the same discounted price for as long as you stay on your plan.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Do I get access to source files?</div>
              <div class="docs__answer">Yes. You get the original source files for every product: Framer, Figma, Sketch, code, 3D assets and more, plus Design DNA for products that support it.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">What are the daily download limits for each plan?</div>
              <div class="docs__answer">Pro: 10 downloads per day. Pro+: 30 downloads per day. Lifetime: 40 downloads per day. Limits reset at midnight Pacific Time.</div>
            </li>
            <li class="docs__item">
              <div class="docs__question">Can my team share one pass?</div>
              <div class="docs__answer">Each pass is licensed to one person. If several team members need access, each needs their own plan. Contact us and we'll help get your team set up.</div>
            </li>
          </ul>
          <div class="docs__hint">Couldn't find what you were looking for? <a onclick="window.$chatwoot && window.$chatwoot.toggle('open')">Contact us</a></div>
        </div>
        <div class="companies">
          <h3 class="companies__title">Chosen by creative teams globally</h3>
          <div class="companies__carousel">
            <ul class="companies__list">
              <li ng-repeat="company in $ctrl.companies">
                <img ng-src="/img/companies/{{ company }}.svg" alt="{{ company }}">
              </li>
            </ul>
            <ul class="companies__list">
              <li ng-repeat="company in $ctrl.companies">
                <img ng-src="/img/companies/{{ company }}.svg" alt="{{ company }}">
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>`,

  controller: function ($location) {
    var ctrl = this;
    var sphere;
    var sphereObserver;

    ctrl.$onDestroy = function () {
      $(".aap__question").off();
      // The sphere runs a WebGL rAF loop; leaving it alive after the route
      // changes would keep rendering an element that no longer exists.
      if (sphereObserver) sphereObserver.disconnect();
      if (sphere && sphere.pause) sphere.pause();
    };

    // Opens the site search with the Framer format filter already applied.
    //
    // There is no URL that expresses that view: openSearch() only sets
    // ?search=1, and the modal keeps its filter state in localStorage rather
    // than in the query string. So the state is seeded first and the modal
    // picks it up in its own $onInit, which runs on every open because the
    // modal is mounted with ng-if. If that storage contract ever changes, the
    // button degrades to opening an unfiltered search rather than breaking.
    ctrl.browseFramerTemplates = function () {
      try {
        localStorage.setItem(
          "srch:search-state",
          JSON.stringify({
            searchTerm: "",
            sortFilter: "popular",
            // keep Popular here rather than search's Recent default
            sortPicked: true,
            selectedFilters: { framer: true },
            selectedTags: {},
            selectedAuthors: {},
            chips: {},
            priceMin: 5,
            priceMax: 99,
          })
        );
      } catch (e) {
        // Private browsing or a full quota: fall through and open unfiltered.
      }
      if (window.openSearch) window.openSearch();
    };

    ctrl.$onInit = function () {
      // Already ranked, narrowed and capped by /api/framer-picks, which
      // refreshes weekly. Rendered in the order it returns.
      ctrl.framerProducts = ctrl.products || [];

      ctrl.companies = [
        "adobe",
        "airbnb",
        "amazon",
        "google",
        "microsoft",
        "netflix",
        "paypal",
        "shopify",
        "spotify",
        "stripe",
        "webflow",
      ];

      window.scrollTo(0, 0);

      // Same interactive sphere as the homepage hero, paused off-screen.
      // Angular renders this template, so the element may not exist on the
      // first frame — and hero-sphere.js is a plain bundle global that may
      // not have run yet — hence the rAF retry, matching pass-details.
      (function waitForHero() {
        var sphereEl = document.getElementById("aap-sphere");
        if (!sphereEl || !window.HeroSphere || !window.HeroSphere.initHero)
          return requestAnimationFrame(waitForHero);

        sphere = window.HeroSphere.initHero(sphereEl, "/img/cards/", null, 30);
        sphereObserver = new IntersectionObserver(function (entries) {
          if (!sphere || !sphere.pause) return;
          if (entries[0].isIntersecting) sphere.resume();
          else sphere.pause();
        });
        sphereObserver.observe(sphereEl);
      })();

      if (!ctrl.data.promo && window.UI8.promo) {
        ctrl.data.promo = window.UI8.promo;
      }
      if (!ctrl.data.lifetime && window.UI8.lifetime) {
        ctrl.data.lifetime = window.UI8.lifetime;
      }
      if (!ctrl.data.subscriptions && window.UI8.subscriptions) {
        ctrl.data.subscriptions = window.UI8.subscriptions;
      }

      if ($location.search().order) {
        $("html, body").animate(
          {
            scrollTop: $(".pricing-heading").offset().top - 180,
          },
          "fast"
        );
      }

      // faq
      const docsItem = $(".docs__item");

      docsItem
        .on("click", function () {
          const _this = $(this);
          if (_this.hasClass("active")) {
            _this.removeClass("active");
            _this.find(".docs__answer").slideUp();
          } else {
            docsItem.removeClass("active");
            docsItem.find(".docs__answer").slideUp();
            _this.addClass("active");
            _this.find(".docs__answer").slideDown();
          }
        })
        .first()
        .trigger("click");
    };
  },

  bindings: {
    data: "<",
    products: "<",
    user: "<",
  },
});
